export default "__VITE_ASSET__CWpn$Bmc__"